import LayoutPage from "../page/layout";



const Homepage = () => {
    return(
        <LayoutPage/>
    )
}
export default Homepage;